import React from 'react';

interface PaymentMethodDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigateToSettings: () => void;
}

const PaymentMethodDialog: React.FC<PaymentMethodDialogProps> = ({
  isOpen,
  onClose,
  onNavigateToSettings,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pt-0 px-4 pb-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white dark:bg-stone-900 w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-6 text-center space-y-4">
          <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/40 rounded-full flex items-center justify-center mx-auto text-amber-500">
            <i className="fa-solid fa-credit-card text-2xl"></i>
          </div>
          <h2 className="text-xl font-serif font-bold text-stone-800 dark:text-stone-100">
             Payment Method Required
          </h2>
          <p className="text-sm text-stone-600 dark:text-stone-400 leading-relaxed">
             A payment method is required to use the AI chat features. Please set up your payment method to proceed.
          </p>
        </div>
        <div className="p-6 bg-stone-50 dark:bg-stone-800/50 border-t border-stone-100 dark:border-stone-800 flex gap-3">
          <button 
            onClick={onClose}
            className="flex-1 py-3 rounded-xl border border-stone-200 dark:border-stone-700 text-stone-600 dark:text-stone-400 font-bold text-sm hover:bg-stone-100 dark:hover:bg-stone-800 transition-colors"
          >
            Later
          </button>
          <button 
            onClick={() => onNavigateToSettings()}
            className="flex-1 py-3 rounded-xl bg-amber-500 text-white font-bold text-sm hover:bg-amber-600 transition-colors shadow-lg shadow-amber-500/20"
          >
            Manage Payment Methods
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodDialog;
